import reducer from './reducers';
export { default as selectors } from './selectors';
export { default as actions } from './actions';
export default reducer;
